import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initializeAwsRum } from './app/monitoring/aws-rum';
import { environment } from './environments/environment';

document.title = environment.appTitle;
initializeAwsRum(environment.rum);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
